import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as S from './styled';

const MenuItem = ({ title, to, icon = false, isActive = undefined, nested = false }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const pathIsExact = pathname === to;
  const pathStartsWith = pathname.startsWith(`${to}/`);
  const isValidPrefixMatch = pathStartsWith && to.split('/').filter(Boolean).length === 1;

  const active = isActive ?? (pathIsExact || isValidPrefixMatch);
  const itemTitle = t(`core:menu.items.${title}`, title);

  return (
    <S.MenuItem active={active}>
      <S.Link to={to} $nested={nested}>
        {icon && (
          <S.IconCircle active={active}>
            <FontAwesomeIcon icon={icon} />
          </S.IconCircle>
        )}
        {itemTitle}
      </S.Link>
    </S.MenuItem>
  );
};

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  to: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  nested: PropTypes.bool,
};

export default MenuItem;
